import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { OrderItemModel } from '../models/order-item.model';

export class OrderItemsApiService extends ApiService {
  static endpoint = 'orders/{order_id}/items';

  /**
   * @param {Number|null} itemId
   * @return {String}
   * @protected
   */
  static buildOrderItemUrl(orderId, itemId = null) {
    return this.buildUrl(itemId).replace('{order_id}', orderId);
  }

  /**
   * @param {String|Number} orderId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderItemModel>>}
   * @public
   */
  static async getAll(orderId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildOrderItemUrl(orderId), {
      ...config,
      dataModel: OrderItemModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} orderId
   * @param {String|Number} itemId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderItemModel>>}
   * @public
   */
  static async get(orderId, itemId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildOrderItemUrl(orderId, itemId), {
      ...config,
      dataModel: OrderItemModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
